import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';

const SvgEu48Rounded = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  "aria-label": "European Union",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#e7e7e7",
  d: "M12 22A10 10 0 1 0 2 12a10 10 0 0 0 10 10z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#004fbb",
  d: "M12 22A10 10 0 1 0 2 12a10 10 0 0 0 10 10"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fc0",
  d: "m12 4.9.23.71H13l-.6.44.22.71-.62-.44-.61.44.23-.71-.62-.44h.75zm-3.14.84.24.7h.74l-.59.45.22.7-.6-.43-.59.45.21-.72-.59-.43h.74zM6.6 8l.21.72h.75L7 9.18l.21.71-.59-.44-.62.42.24-.7-.59-.45h.75zm-1.73 3.79h.74l.23-.71.23.71h.74l-.61.44.23.71-.59-.45-.61.43.23-.7zM6 16l.23-.72-.61-.42h.75l.22-.72.23.7h.76l-.58.4.24.71-.62-.44zm2.33 2.24.22-.71-.55-.44h.7l.23-.71.23.71h.74l-.6.44.23.71-.61-.44zm3.14.86.21-.72-.61-.38h.74l.22-.7.24.69H13l-.58.45.25.7-.62-.42zm4.2-.86-.6-.43-.61.44.23-.71-.61-.44h.75l.23-.71.24.7h.7l-.6.44zM18 16l-.61-.43-.6.44.22-.72-.6-.42h.74l.23-.72.24.7h.75l-.61.44zm1.13-4.18-.61.42.21.72-.59-.46-.62.42.25-.71-.58-.45h.74l.26-.71.2.72zm-.84-3.14-.61.43.23.71-.61-.45-.6.43.24-.7-.6-.45h.75l.24-.65.21.72zM16 6.39l-.6.43.22.71-.62-.44-.61.43.24-.71-.59-.44h.74l.22-.7.23.71z"
}));

export { SvgEu48Rounded as default };
//# sourceMappingURL=Eu48Rounded.js.map
